import { forwardRef } from 'react';
import { getRem, truncateText, typographyGroupLabel, visuallyHidden } from 'lib/core';
import { removeObjectProperties } from 'lib/utilities';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledMenuListGroupItem = styled.span.attrs({ disabled: true })`
  ${({ theme }) => typographyGroupLabel(theme)}
  ${truncateText}
    box-sizing: border-box;
  display: block;
  font-weight: ${({ theme }) => theme.font.weight.bold.value};
  margin-bottom: ${({ theme }) => theme.size.spacing.small.value};
  margin-top: ${getRem('12px')};
  padding: 0 ${getRem('12px')};
  ${({ $isVisuallyHidden }) => $isVisuallyHidden && visuallyHidden}
`;

const MenuListGroupItem = forwardRef((props, ref) => {
  const { isVisuallyHidden, ...filteredProps } = removeObjectProperties(props, 'isKeyboardFocused', 'showCheckbox');
  return <StyledMenuListGroupItem {...filteredProps} $isVisuallyHidden={isVisuallyHidden} ref={ref} />;
});

export { MenuListGroupItem };

MenuListGroupItem.propTypes = {
  /** If true, hidden styles apply */
  isVisuallyHidden: PropTypes.bool,
};
